import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { Faq } from 'src/app/core/models/faq.model';
import { FaqService } from 'src/app/core/services/faq.service';

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  styleUrls: ['./faq-view.component.scss',],
})
export class FaqViewComponent implements OnInit {
  faqs: Faq[] = [];

  selectedFaq?: Faq;
  selectedFaqIndex = AppConstants.ZERO;

  constructor(
    private _faqService: FaqService,
    private _router: Router,
    @Inject(PLATFORM_ID) private readonly _platformId: Object
  ) { }

  ngOnInit(): void {
    /**
     * TODO : handle fetch local json
     * ERROR : ERROR NetworkError at XMLHttpRequest.send
     * REASON : Error due to fetching local json (angular universal)
     */
    if (isPlatformBrowser(this._platformId)) this._getFaqs();
  }

  _getFaqs() {
    this._faqService.getFaqs().subscribe({
      next: (data: Faq[]) => {
        this.faqs = data;
        this.updateFaqs();
      },
    });
  }

  updateFaqs() {
    this.selectedFaq = this.faqs[this.selectedFaqIndex];
  }

  onFaqSelect(index: number) {
    this.selectedFaqIndex = index;
    this.updateFaqs();
  }

  toggleFaq(index: number) {
    if (!this.selectedFaq) return;
    this.selectedFaq.faqs[index].isOpen = !this.selectedFaq.faqs[index].isOpen;
  }

  navigate() {
    this._router.navigateByUrl('contact-us');
  }
}

